import React from 'react';
import styles from '@/modules/pipelines/components/deep-dive/asset-metrics/breakdown-bar.module.scss';

export interface BreakdownSegment {
  key: string;
  label: string;
  count: number;
  color: string;
}

export function BreakdownBar({ segments, total }: { segments: BreakdownSegment[]; total: number }) {
  if (total <= 0) return null;

  return (
    <div className={styles.bar} aria-hidden={'true'}>
      {segments
        .filter(segment => segment.count > 0)
        .map(segment => (
          <div
            key={segment.key}
            className={styles.segment}
            style={
              {
                width: `${(segment.count / total) * 100}%`,
                '--segment-color': segment.color,
              } as React.CSSProperties
            }
            title={`${segment.label}: ${segment.count.toLocaleString()}`}
          />
        ))}
    </div>
  );
}

export function BreakdownLegend({ segments }: { segments: BreakdownSegment[] }) {
  return (
    <ul className={styles.legend}>
      {segments.map(segment => (
        <li key={segment.key} className={styles.legendRow}>
          <span
            className={styles.legendDot}
            style={{ '--segment-color': segment.color } as React.CSSProperties}
            aria-hidden={'true'}
          />
          <span className={styles.legendLabel}>{segment.label}</span>
          <span className={styles.legendCount}>{segment.count.toLocaleString()}</span>
        </li>
      ))}
    </ul>
  );
}
